
import wx from 'weixin-js-sdk'
import { getConfig, addFile } from '@/api/wx.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import {
getDetail,
getFlow,
verifyPass,
verifyRefuse,
publish,
offline
} from '@/api/mamixiaowu'
import config from '@/config/index'
export default {
name: 'declareDetail',
directives: {
TransferDom
},
components: { Cell, Group, Popup, XTextarea },
data () {
return {
baseUrl: config.baseUrl,
show: false,
obj: {},
flowList: [],
sourcetype: 1,
id: this.$route.params.id,
status: '',
result: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
auth () {
return this.$store.state.user.workerObj.auth || ''
},
areatype () {
return this.$store.state.user.workerObj.areatype
}
},
mounted () {
this.wxconfig()
this.getDetail()
this.getFlow()
},
methods: {
getDetail () {
getDetail({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id
}).then(res => {
this.obj = res.returnValue
})
},
getFlow () {
getFlow({
id: this.id
}).then(res => {
this.flowList = res.returnValue.list
})
},
verify () {
this.show = true
},

publish () {
publish({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id
}).then(res => {
let _this = this
this.$vux.alert.show({
content: '提交成功',
onHide () {
_this.$router.go(-1)
}
})
})
},

offline () {
offline({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id
}).then(res => {
let _this = this
this.$vux.alert.show({
content: '提交成功',
onHide () {
_this.$router.go(-1)
}
})
})
},
cancel () {
this.show = false
},
edit () {
this.$router.push({ name: 'mamixiaowuDeclareEdit', params: { id: this.id } })
},
submit () {
if (this.status === '1') {

verifyPass({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id,
result: this.result
}).then(res => {
let _this = this
this.$vux.alert.show({
content: '提交成功',
onHide () {
_this.$router.go(-1)
}
})
})
} else if (this.status === '2') {

if (this.result === '') {
this.$vux.toast.text('请填写审核意见')
return false
}
verifyRefuse({
accountid: this.accountid,
sourcetype: this.sourcetype,
id: this.id,
result: this.result
}).then(res => {
let _this = this
this.$vux.alert.show({
content: '提交成功',
onHide () {
_this.$router.go(-1)
}
})
})
}
},


wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['previewImage'] 
})
})
},

preview (index, fileList) {
let arr = fileList.map(item => this.baseUrl + item.filepath)
wx.previewImage({
current: arr[index], // 当前显示图片的http链接
urls: arr 
})
}
}
}
